import React from 'react';

const PartnerFooter = () => {
  return (
    <>
      <p>Terms & Conditions</p>
      <p>Privacy Statement</p>
    </>
  );
};

export default PartnerFooter;
